import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 23"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M0 11.534C0 19.167 2.843 23 8.494 23c3.189 0 5.477-1.221 6.69-3.392 1.248-2.171 1.734-4.682 1.734-8.074s-.486-5.97-1.734-8.142C13.971 1.222 11.683 0 8.494 0 2.843 0 0 3.833 0 11.534m4.853 0q0-6.92 3.64-6.92c2.393 0 3.571 2.306 3.571 6.92 0 4.58-1.178 6.852-3.57 6.852-2.427 0-3.64-2.272-3.64-6.852m15.41-7.328V8.38l3.883-1.628v15.91H29V.136z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }